import mapboxgl from 'mapbox-gl'
import i18n from "../../i18n";

const BUDAPEST = 'Budapest'

export class AdminStatPopup extends mapboxgl.Popup {
  constructor(options) {
    let popupOptions = {
      ...options,
      closeOnMove: false,
      closeOnClick: false,
      closeButton: true,
      className: 'adminstat-popup',
      maxWidth: '300px'
    }
    super(popupOptions)
  }
  generateAreaStatControl(data) {
    let control = document.createElement('div')
    control.className = "adminstat-popup-content"
    let address = document.createElement('span')
    address.className = "adminstat-popup-address"
    let addressString = (data.addressparts.zip ? (data.addressparts.zip + " ") : "") +
      data.addressparts.city +
      (data.addressparts.street ? ",<br>" + data.addressparts.street : "") +
      (data.addressparts.hnum ? " " + data.addressparts.hnum : "")
    address.innerHTML = addressString
    control.appendChild(address)
    let line = document.createElement('hr')
    control.appendChild(line)
    let city = document.createElement('span')
    city.className = "adminstat-popup-admin"
    let cityString = "<b>" + (data.addressparts.city === BUDAPEST ? data.addressparts.district : data.addressparts.city) + "</b>" +
      "<br>" + data.city.sicks + ` ${i18n.t('ill')} / ` + data.city.population + ` ${i18n.t('inhabitants')}` +
      "<br>" + (data.city.sicks / data.city.population * 1000).toFixed(2) + ` ${i18n.t('ill')} / 1000 ${i18n.t('inhabitants')}`
    city.innerHTML = cityString
    control.appendChild(city)
    let county = document.createElement('span')
    county.className = "adminstat-popup-admin"
    let countyString = "<b>" + data.addressparts.county.replace('megye',i18n.t('county')) + "</b>" +
      "<br>" + data.county.sicks + ` ${i18n.t('ill')} / ` + data.county.population + ` ${i18n.t('inhabitants')}` +
      "<br>" + (data.county.sicks / data.county.population * 1000).toFixed(2) + ` ${i18n.t('ill')} / 1000 ${i18n.t('inhabitants')}`
    county.innerHTML = countyString
    control.appendChild(county)
    return control
  }
  open(map, data, lngLat) {
    if (this.isOpen()) {
      this.remove()
    }
    if (data) {
      let control = this.generateAreaStatControl(data)
      this.setDOMContent(control)
      this.setLngLat(lngLat)
      this.addTo(map)
    }
  }
}
